<template>
    <div class="login">
        <el-form ref="form" :model="form" label-width="80px" label-position="top">
            <el-form-item label="登录">
                <el-input type="text" name="name" v-model="form.name"></el-input>
                <el-input type="password" name="password" v-model="form.password"></el-input>
            </el-form-item>
            <el-button @click="login" type="primary" size="mini">登录</el-button>
        </el-form>
    </div>
</template>
<script>
    import $ from 'jquery'
    export default{
        name:'login',
        data(){
            return {
                form:{
                    name:'admin',
                    password:'123456',
                }
            }
        },
        methods:{
            login(){
                if(this.$cookie.get("backstageModelName") === 'admin'){
                    this.$parent.router = '/home';
                    this.$routerGo(this, '/home');
                }else{
                    this.$cookie.set("backstageModelName", this.form.name, 3)
                    this.$cookie.set("backstageModelPassword", this.form.password, 3)
                    this.$parent.router = '/home';
                    this.$routerGo(this, '/home');
                }
            },
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/login.vue